<div class='claims-processor-main' data-cy="claims-processor-container">
  <!--  <mat-progress-spinner *ngIf="isLoading" style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%)" diameter="100" mode="indeterminate"></mat-progress-spinner>-->
  <mat-grid-list cols="6" rowHeight="100%" style="height:100%;" data-cy="claims-processor-grid">
    <mat-grid-tile colspan="2" data-cy="claims-processor-list-tile">
      <mat-card appearance="outlined" style="width:100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="claims-processor-list-card">
        <span class="configuration-section-title" data-cy="claims-processor-list-title">Claims Processors</span>
        <div style="flex: 1; height: 700px; overflow-y: hidden;" data-cy="claims-processor-table-container">
          <tdo-table #processorTable (rowSelected)="onTdoTableItemClick($event)" [dataSource]="claimProcessorList" [isSearchable]="false" [isUsePaginator]="false" sortActive="Name" sortDirection="asc" data-cy="claims-processor-table">
            <tdo-table-column [isSortable]="false" displayName="Name" propertyName="Name" [rowTemplate]="processor" data-cy="claims-processor-name-column">
              <ng-template let-row #processor>
                <span data-cy="claims-processor-name-value">{{ row.model.Name }}</span>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column [isSortable]="false" displayName="Remove" propertyName="xauditDeleted" [rowTemplate]="del" data-cy="claims-processor-remove-column">
              <ng-template let-row #del>
                <div (click)="removeProcessor(row.model)" matTooltip="Remove processor"
                     style="padding-right:16px; cursor: pointer; color: var(--tdo-secondary);" data-cy="claims-processor-remove-btn"><mat-icon>delete</mat-icon></div>
              </ng-template>
            </tdo-table-column>
          </tdo-table>
        </div>

      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile colspan="2" data-cy="claims-processor-details-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="claims-processor-details-card">
        <mat-card-content data-cy="claims-processor-details-content">
          <div style="max-width: 700px;" data-cy="claims-processor-details-container">

            <app-tdo-configuration-action-bar
              #actionBar
              [showEdit]="(!isEditing && this.selectedProcessor != null)"
              (editClick)="onEdit($event)"
              [saveDisabled]="saveDisabled || (selectedProcessor ? (selectedProcessor.Name ? selectedProcessor.Name : '') : '').trim() === ''"
              [showSave]="!saveDisabled"
              [showCancel]="!saveDisabled"
              (saveClick)="onSave($event)"
              (cancelClick)="onCancel($event)"
              (newClick)="onNewProcessor($event)"
              [showAdd]="false"
              [newHidden]="false"
              data-cy="claims-processor-action-bar">
            </app-tdo-configuration-action-bar>

            <span class="configuration-section-title" data-cy="claims-processor-info-title">Claims Processor Information</span>
            <div style="display:flex; flex-direction: column; height: 775px" data-cy="claims-processor-form-container">

              <div style="flex: 1; overflow: auto" data-cy="claims-processor-form">
                <mat-form-field class="flex-column-item mat-select-margin" style="width:100%" data-cy="claims-processor-name-field">
                  <mat-label data-cy="claims-processor-name-label">Name</mat-label>
                  <input matInput [(ngModel)]="this.selectedProcessor.Name" [disabled]="!this.isEditing" data-cy="claims-processor-name-input">
                </mat-form-field>

                <mat-form-field style="width:100%; margin-top: 3px;" data-cy="claims-processor-type-field">
                  <mat-label data-cy="claims-processor-type-label">Processor</mat-label>
                  <mat-select [(value)]="selectedProcessor.enumARClaimProcessorID" (selectionChange)="setProcessorType($event.value)" [disabled]="!this.isEditing" data-cy="claims-processor-type-select">
                    <mat-option *ngFor="let type of claimProcessorTypesList" [value]="type.ValidValueItemId" data-cy="claims-processor-type-option">
                      {{ type.ItemDisplayValue }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <!--dxc-->
                <div *ngIf="selectedProcessor.enumARClaimProcessorID === '00000223-1000-0000-0000-000000000001'" data-cy="claims-processor-dxc-container">

                  <mat-form-field class="flex-column-item mat-select-margin" style="width:100%" data-cy="claims-processor-website-field">
                    <mat-label data-cy="claims-processor-website-label">Website (Read Only)</mat-label>
                    <input matInput [(ngModel)]="this.selectedProcessor.WebSiteURL" [disabled]="true" data-cy="claims-processor-website-input">
                  </mat-form-field>

                  <mat-form-field class="flex-column-item mat-select-margin" style="width:100%" data-cy="claims-processor-apikey-field">
                    <mat-label data-cy="claims-processor-apikey-label">TDOPro API Key (Read Only)</mat-label>
                    <input matInput [(ngModel)]="dxc_APIKey" [disabled]="true" data-cy="claims-processor-apikey-input">
                  </mat-form-field>


                  <mat-form-field class="flex-column-item mat-select-margin" style="width:100%" data-cy="claims-processor-dxcgroup-field">
                    <mat-label data-cy="claims-processor-dxcgroup-label">DentalXchange Account Number (prefix number with a dash)</mat-label>
                    <input matInput [(ngModel)]="dxc_DXCGroupID" [disabled]="!this.isEditing" data-cy="claims-processor-dxcgroup-input">
                  </mat-form-field>

                  <mat-form-field class="flex-column-item mat-select-margin" style="width:100%" data-cy="claims-processor-username-field">
                    <mat-label data-cy="claims-processor-username-label">DentalXchange User Name</mat-label>
                    <input matInput [(ngModel)]="dxc_UserName" [disabled]="!this.isEditing" data-cy="claims-processor-username-input">
                  </mat-form-field>

                  <mat-form-field class="flex-column-item mat-select-margin" style="width:100%" data-cy="claims-processor-password-field">
                    <mat-label data-cy="claims-processor-password-label">DentalXchange Password</mat-label>
                    <input matInput [(ngModel)]="dxc_password" [disabled]="!this.isEditing" data-cy="claims-processor-password-input">
                  </mat-form-field>
                </div>

                <div *ngIf="false" data-cy="claims-processor-additional-fields">
                  <mat-form-field class="flex-column-item mat-select-margin" style="width:100%" data-cy="claims-processor-website-alt-field">
                    <mat-label data-cy="claims-processor-website-alt-label">Website</mat-label>
                    <input matInput [(ngModel)]="this.selectedProcessor.WebSiteURL" [disabled]="!this.isEditing" data-cy="claims-processor-website-alt-input">
                  </mat-form-field>

                  <div data-cy="claims-processor-connection-params">
                    <div *ngFor="let item of connectionParametersJSON | keyvalue; let i=index; trackBy:trackByFn" data-cy="claims-processor-param-item">
                      <app-tdo-input *ngIf="item.key !== 'IsPaired' && item.key !== 'Password'" [(ngModel)]="connectionParametersJSON[item.key]"
                                     style="width:100%" [placeholder]="item.key" [disabled]="!this.isEditing" data-cy="claims-processor-param-input"></app-tdo-input>

                      <div *ngIf="item.key === 'Password'" style="display: flex" data-cy="claims-processor-password-container">
                        <div style="flex:3" data-cy="claims-processor-password-input-container">
                          <mat-form-field style="width:100%" data-cy="claims-processor-password-alt-field">
                            <mat-label data-cy="claims-processor-password-alt-label">Password</mat-label>
                            <input matInput [type]="PasswordEyeShowMode" [(ngModel)]="connectionParametersJSON[item.key]" [disabled]="!this.isEditing" data-cy="claims-processor-password-alt-input">
                          </mat-form-field>
                        </div>
                        <div style="flex:1" data-cy="claims-processor-password-toggle">
                          <button (click)="onClickPasswordEye()" data-cy="claims-processor-password-toggle-btn">
                            <i class="fa fa-eye" aria-hidden="true" *ngIf="!PasswordEyeShow" data-cy="claims-processor-password-show-icon"></i>
                            <i class="fa fa-eye-slash" aria-hidden="true" *ngIf="PasswordEyeShow" data-cy="claims-processor-password-hide-icon"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="this.isLoading" data-cy="claims-processor-loading-container">
                <mat-spinner style="margin-left: auto; margin-right: auto;" data-cy="claims-processor-details-spinner"></mat-spinner>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile colspan="2" data-cy="claims-processor-locations-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="claims-processor-locations-card">
        <mat-card-content data-cy="claims-processor-locations-content">
          <div style="padding-top: 55px" data-cy="claims-processor-locations-header">
            <span class="configuration-section-title" data-cy="claims-processor-locations-title">Locations</span>
          </div>

          <div style="flex: 1; height: 700px; overflow-y: hidden;" data-cy="claims-processor-locations-container">
            <tdo-table #locationTable [dataSource]="claimProcessorLocationList" [isSearchable]="false" [isUsePaginator]="false" sortActive="Name" sortDirection="asc" data-cy="claims-processor-locations-table">

              <tdo-table-column [isSortable]="false" displayName="" propertyName="isProcessorLocation" [rowTemplate]="locSelected" class="mat-column-left-checkbox" data-cy="claims-processor-location-column">
                <ng-template let-row #locSelected>
                  <mat-checkbox [(ngModel)]="row.model.isProcessorLocation" [disabled]="!this.isEditing" data-cy="claims-processor-location-checkbox">{{ row.model.Name }}</mat-checkbox>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column [isSortable]="false" displayName="Default" propertyName="isDefaultProcessor" [rowTemplate]="defaultSelected" data-cy="claims-processor-default-column">
                <ng-template let-row #defaultSelected>
                  <div style="padding-right:16px" data-cy="claims-processor-default-container">
                    <mat-checkbox [(ngModel)]="row.model.isDefaultProcessor" [disabled]="!this.isEditing" data-cy="claims-processor-default-checkbox"></mat-checkbox>
                  </div>
                </ng-template>
              </tdo-table-column>
            </tdo-table>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>



